import { AccessGrantMessage } from './AccessGrantMessage';
import { ContentMessage } from './ContentMessage';
import { jsx as _jsx } from "react/jsx-runtime";
export const ThreadMessage = props => {
  switch (props.message['@type']) {
    case 'CUSTOMER_PORTAL_ACCESS_GRANT_MESSAGE':
      return /*#__PURE__*/_jsx(AccessGrantMessage, {
        message: props.message
      });
    case 'INITIAL_MESSAGE':
      return /*#__PURE__*/_jsx(ContentMessage, Object.assign({}, props, {
        isInitialMessage: true
      }));
    default:
      return /*#__PURE__*/_jsx(ContentMessage, Object.assign({}, props));
  }
};